import { Star } from "lucide-react";
import { useReviews } from "./GoogleBadge";

const Stars = ({ n }) => <span className="flex gap-0.5 text-[#C25E38]" aria-label={`${n} sur 5`}>{[1, 2, 3, 4, 5].map((i) => <Star key={i} size={14} fill={i <= n ? "currentColor" : "none"} />)}</span>;

export function Reviews() {
  const d = useReviews();
  if (!d || d.reviews.length === 0) return null;
  const avg = d.rating || d.reviews.reduce((a, r) => a + (Number(r.rating) || 5), 0) / d.reviews.length;
  const count = d.count || d.reviews.length;
  const ld = { "@context": "https://schema.org", "@type": "LocalBusiness", name: "Atelier KOUOH", aggregateRating: { "@type": "AggregateRating", ratingValue: Number(avg).toFixed(1), reviewCount: count }, review: d.reviews.slice(0, 6).map((r) => ({ "@type": "Review", author: { "@type": "Person", name: r.author }, reviewRating: { "@type": "Rating", ratingValue: r.rating || 5 }, reviewBody: r.text, ...(r.date ? { datePublished: r.date } : {}) })) };
  return (
    <section className="k-section" data-testid="reviews-block">
      <script type="application/ld+json">{JSON.stringify(ld)}</script>
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div><p className="k-eyebrow">Ils nous font confiance</p><h2 className="k-h2 mt-3">Ce que disent nos clients.</h2></div>
        <div className="flex items-center gap-3"><Stars n={Math.round(avg)} /><span className="text-sm text-[#57534E]">{Number(avg).toFixed(1)} / 5 · {count} avis Google</span></div>
      </div>
      <div className="mt-10 grid gap-6 md:grid-cols-3">
        {d.reviews.slice(0, 6).map((r, i) => (
          <blockquote key={i} className="k-card p-6 flex flex-col gap-4" data-testid={`review-${i}`}>
            <Stars n={Number(r.rating) || 5} />
            <p className="text-[#44403c] leading-relaxed">« {r.text} »</p>
            <footer className="flex items-center gap-3 mt-auto">
              {r.photo ? <img src={r.photo} alt="" className="w-8 h-8 rounded-full object-cover" loading="lazy" referrerPolicy="no-referrer" /> : <span className="w-8 h-8 rounded-full bg-[#E8E2D8] flex items-center justify-center text-xs font-medium">{(r.author || "?")[0]}</span>}
              <span className="text-xs uppercase tracking-widest text-[#8C857B]">{r.author}{r.role ? ` · ${r.role}` : ""}{r.date ? ` · ${new Date(r.date).toLocaleDateString("fr-FR", { month: "short", year: "numeric" })}` : ""}</span>
            </footer>
          </blockquote>
        ))}
      </div>
      {d.google_url && <a href={d.google_url} target="_blank" rel="noopener noreferrer" className="k-link text-sm mt-8 inline-block" data-testid="reviews-google-link">Voir tous nos avis sur Google →</a>}
    </section>
  );
}
